/**
 * UTILITY per controlli unificati tra composable e store in caso di reso completo
 */

type Capo = { returnable?: boolean; to_return?: boolean }
type Pagamento = {
  codice_movimento?: string // 'CONTABILITA_PAGAMENTO' o altro
  cod_operazione?: string // 'BUONO' o altro
  returnable?: boolean
  standalone?: boolean
  to_return?: boolean
  is_promo?: boolean
}

/**
 * True se la vendita è Tax Free.
 */
export function isTaxFree(attributes): boolean {
  if (!attributes) {
    return false
  }
  return attributes.cod_documento === 'SALE_TAXFREE'
}

/**
 * True se esiste almeno un capo e tutti sono returnable.
 * Nessun capo -> false (non abilita full return).
 */
export function areAllItemsReturnable(capi?: Capo[] | null): boolean {
  const listaCapi = capi ?? []
  return listaCapi.length > 0 && listaCapi.every((item) => !!item.returnable)
}

/**
 * True se:
 *  - tutti i pagamenti di contabilità sono validi (nessun 'BUONO'), e
 *  - i pagamenti non di contabilità sono assenti oppure tutti returnable.
 * Nessun pagamento -> true (non blocca il full return).
 */
export function areAllPaymentsReturnable(
  pagamenti?: Pagamento[] | null,
): boolean {
  const listaPagamenti = pagamenti ?? []
  if (listaPagamenti.length === 0) {
    return true
  }

  const pagamentiContabilita = listaPagamenti.filter(
    (p) => p.codice_movimento === 'CONTABILITA_PAGAMENTO',
  )
  const pagamentiNonContabilita = listaPagamenti.filter(
    (p) => p.codice_movimento !== 'CONTABILITA_PAGAMENTO' && !p.is_promo,
  )

  const pagamentiContabilitaValidi = pagamentiContabilita.every(
    (p) => p.cod_operazione !== 'BUONO',
  )

  const pagamentiNonContabilitaValidi =
    pagamentiNonContabilita.length === 0 ||
    pagamentiNonContabilita.every((p) => !!p.returnable)

  return pagamentiContabilitaValidi && pagamentiNonContabilitaValidi
}

/**
 * Condizione unificata per abilitare il "full return" (reso totale).
 * Equivalente alla logica di UI/Store:
 *   (tutti capi rendibili && tutti pagamenti compatibili) || isTaxFree
 */
export function canActivateFullReturnRule(attributes): boolean {
  if (!attributes) {
    return false
  }

  const okCapi = areAllItemsReturnable(attributes.capi)
  const taxFree = isTaxFree(attributes)

  return okCapi || taxFree
}

/**
 *  Verifica se esistono pagamenti selezionabili singolarmente
 */
export function getStandaloneSelectablePayments(
  pagamenti: Pagamento[] = [],
): Pagamento[] {
  // Per il ramo “parziale standalone”
  return pagamenti.filter(
    (p) =>
      p.returnable && p.standalone && p.codice_movimento !== 'CONTABILITA_GIFT',
  )
}
